/**
 * Creates a back-click handler for UnitV3. For now it routes back to the
 * DWB lessons landing; future grade-band aware behavior should mirror the
 * TieredInterventionsUnits helper once DWB course slugs are finalized.
 */
export const handleBackClick = ({ navigationEvent }) => {
  return () => {
    navigationEvent('/product/digital-well-being/lessons')
  }
}

/**
 * Factory for the unit-tab change handler. Mirrors TieredInterventionsUnits
 * so that downstream code can swap the page in without rewiring callers.
 */
export const handleTabChange = ({ location, navigationEvent }) => {
  return tab => {
    const { search } = location || {}
    const destination = `${tab?.route}?${new URLSearchParams(
      search,
    )?.toString()}`
    navigationEvent(destination)
  }
}
